module.exports = __webpack_public_path__ + "static/img/passportClosed.a99f444.png";